import * as Enum from '@owl-nest/legacy-enum'

export const PM_MENU_WIDTH = `228px`
export type BreakpointType = 'tablet' | 'custom-project-edit-mode'

export const BREAKPOINT_PROJECT_EDIT_MODE = '(min-width: 995px)'

export const Screen = Enum.create({
  ACCOUNT: 'account',
  ANALYTICS: 'analytics',
  DASHBOARD: 'dashboard',
  DELIVERY: 'delivery',
  DISCUSSIONS: 'discussions',
  FAQ: 'faq',
  GOAL: 'goal',
  IMPACT: 'impact',
  LAUNCH: 'launch',
  LOCATION: 'location',
  MEMBERS: 'members',
  MEMBERSHIPS: 'memberships',
  MY_PROJECT: 'my-project',
  NEWS: 'news',
  OFFBOARDING: 'offboarding',
  OFFLINE_DONATIONS_LIST: 'list',
  ORDERS: 'orders',
  PRESENTATION: 'presentation',
  PRE_LAUNCH: 'prelaunch',
  REFERRALS: 'referrals',
  REWARDS: 'rewards',
  TAX_DEDUCTION: 'taxdeduction',
  TEAM: 'team',
})
export type Screen = Enum.ValueOf<typeof Screen>

export const allScreens: string[] = Object.values(Screen)

export const pureBackofficeScreens: string[] = [
  Screen.ACCOUNT,
  Screen.ANALYTICS,
  Screen.DASHBOARD,
  Screen.DELIVERY,
  Screen.GOAL,
  Screen.IMPACT,
  Screen.LAUNCH,
  Screen.LOCATION,
  Screen.MEMBERS,
  Screen.MEMBERSHIPS,
  Screen.NEWS,
  Screen.OFFBOARDING,
  Screen.ORDERS,
  Screen.PRESENTATION,
  Screen.PRE_LAUNCH,
  Screen.REFERRALS,
  Screen.REWARDS,
  Screen.TAX_DEDUCTION,
  Screen.TEAM,
]

export const PURE_BACKOFFICE_PATHS = {
  ACCOUNT: `/${Screen.ACCOUNT}`,
  ANALYTICS: `/${Screen.ANALYTICS}`,
  DASHBOARD: `/${Screen.DASHBOARD}`,
  GOAL: `/${Screen.GOAL}`,
  IMPACT: `/${Screen.IMPACT}`,
  LAUNCH: `/${Screen.LAUNCH}`,
  LOCATION: `/${Screen.LOCATION}`,
  MEMBERS: `/${Screen.MEMBERS}`,
  MEMBERSHIPS: `/${Screen.MEMBERSHIPS}`,
  NEWS: `/${Screen.NEWS}`,
  OFFBOARDING: `/${Screen.OFFBOARDING}`,
  ORDERS: `/${Screen.ORDERS}`,
  PRESENTATION: '/',
  PRE_LAUNCH: `/${Screen.PRE_LAUNCH}`,
  REFERRALS: `/${Screen.REFERRALS}`,
  REWARD: `/${Screen.REWARDS}`,
  TAX_DEDUCTION: `/${Screen.TAX_DEDUCTION}`,
  TEAM: `/${Screen.TEAM}`,
} as const
